import React from 'react';

import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';

const ItemSchema = {
  title: 'Value',
  properties: {
    text: {
      title: 'Text',
      widget: 'text',
    },
    link: {
      title: 'Link',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
    },
    open_in_new_tab: {
      title: 'Open link in new tab',
      type: 'boolean',
    },
  },
  fieldsets: [
    {
      id: 'default',
      title: 'Value',
      fields: ['text', 'link', 'open_in_new_tab'],
    },
  ],
  required: ['text', 'link', 'open_in_new_tab'],
};

const LinksWidget = (props) => {
  return (
    <ObjectListWidget
      schema={ItemSchema}
      {...props}
      value={props.value?.items || props.default?.items || []}
      onChange={(id, value) => props.onChange(id, { items: value })}
    />
  );
};

export default LinksWidget;
